const state = {
  form: {
    institutionType: 2,
    institutionName: '',
    username: '',
    mobile: '',
    smsCode: '',
    password: '',
    bureauId: '',
    status: 0,
    agreement: false,
    page: 0,
  },
}
const mutations = {
  changePersonage(state, num) {
    state.form.institutionType = num
  },
  changeInformation(state, obj) {
    state.form = { ...state.form, ...obj }
  },
  changeStatus(state, status) {
    state.form.status = status
  },
  changeStatus(state, status) {
    state.form.status = status
  },
  emptyRegister(state, form) {
    state.form = form
  },
  changeAgreement(state, agreement) {
    state.form.agreement = agreement
  },
  changePage(state, page) {
    state.form.page = page
  },
}
const actions = {}
const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
